import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsGithub} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'
const Linksocial = () => {
  return (
    <div className='header-social'>
        <a href='https://www.linkedin.com/in/gagan-shukla-972713228/'target="_blank"><BsLinkedin/></a>
        <a href='https://github.com/Gaganshukla01'target="_blank"><BsGithub/></a>
        <a href='https://www.instagram.com/gagan._shukla/'target="_blank"><BsInstagram/></a>
    </div>
  )
}

export default Linksocial;